import Api from "repository/Api"

export const createTicket = async (ticketType, priority, subject, notes, projectId, attachments) => {
    const data = {
        ticketType,
        priority,
        subject,
        notes,
        project: `/api/projects/${projectId}`,
        attachments
    }
    const res = await Api.post("/tickets", data);
    return res.data;
};
